/**
 * TechnologyAssetsTab Component
 *
 * Thin wrapper component for displaying affected assets in the TechnologyDrawer.
 * Renders the TechnologyAssetsTable with predefined configuration.
 *
 * Pattern follows VulnerabilityDrawer's AssetsTab implementation.
 */

import { TechnologyAssetsTable } from '@/sections/technology/components/drawer/TechnologyAssetsTable';

interface TechnologyAssetsTabProps {
  /** The technology key to filter assets by */
  technologyKey: string;
}

/**
 * TechnologyAssetsTab displays assets impacted by a specific technology
 *
 * @param technologyKey - The unique identifier for the technology
 */
export function TechnologyAssetsTab({
  technologyKey,
}: TechnologyAssetsTabProps) {
  return (
    <div className="size-full">
      <TechnologyAssetsTable
        technologyKey={technologyKey}
        drawerFilters={['status', 'attackSurface', 'protocol', 'port']}
      />
    </div>
  );
}
